"use client";

import React from "react";
import { Play, Clock, BookOpen, MonitorPlay } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const videoLibrary = [{
  id: "vid-001",
  topicCode: "LEADERSHIP",
  title: "Who This Is For",
  duration: "12:45",
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/ceo_mindset.png",
  description: "For any Founder,, CEO, executive or investor who feels like they’ve plateaued and are tired of experiencing stagnate performance OR wants more protection, support & breakthroughs to build on their performance.\xA0 \xA0 Wants to more easily overcome stresses, vices, negativity and obstacles by having the knowledge and support to be more enlightened consciousness based leader."
}, {
  id: "vid-002",
  topicCode: "MINDSET",
  title: "Go Beyond Stagnate & Stuck to Superfluid Progress",
  duration: "15:20",
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/high_performance.png",
  description: "Have even more capacity to have relevant strategic insights to lead from a place of even greater clarity, coherence & creativity"
}, {
  id: "vid-003",
  topicCode: "STRATEGY",
  title: "Investing In You Removes Obstacles to Progress",
  duration: "10:15",
  thumbnail: "https://newmavericks.com/wp-content/uploads/2026/03/buffet.jpeg?v=37yy75eqkal",
  description: "“Investing in yourself is the most important investment you’ll make in your life. There’s no financial investment that’ll ever match it because if you develop more skill, more ability, more insight, more capacity, that’s what’s going to really prove economic freedom. It’s those skills that really make that happen.” – Warren Buffet"
}, {
  id: "vid-004",
  topicCode: "PERFORMANCE",
  title: "Accelerating Deal Closures & Objectives",
  duration: "18:30",
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/deal_closures.png",
  description: "Move beyond traditional management to a state of spontaneous right action and profound market insight."
}, {
  id: "vid-005",
  topicCode: "CULTURE",
  title: "Create A High Performance Culture Based on Consciousness",
  duration: "14:50",
  thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/global_success.png",
  description: "Transform organizational energy by elevating the collective consciousness & coherence of yourself and leadership team."
}, {
  id: "vid-006",
  topicCode: "SUCCESS",
  title: "Sustainable Success in the Global Market",
  duration: "22:10",
  thumbnail: "https://newmavericks.com/wp-content/uploads/2026/03/Screen-Shot-2026-02-12-at-8.29.28-PM.png?v=s6jybc79qq8",
  description: "Achieve long-term growth without burnout by mastering the inner dynamics of achievement and pressure by increasing connectivity and coherence between your 100 billion neurons to be more in tune with change and less affected by the stress & negativity so you protect & build on what you create."
}];
export default function Video() {
  return <section data-section-id="168412" id="videopresentation" className="bg-background text-black py-20 ![margin:0px_0px_-30px_0px] md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ![margin:-60px_0px_64px_0px]">
          <div className="max-w-3xl">
            <h2 className="font-display text-[32px] leading-[1.2em] font-bold tracking-tight !text-[hsl(0,0%,100%)] ![margin:-20px_0px_24px_0px] md:text-5xl md:leading-tight">Be Established in the Highest Level of CEO Leadership</h2>
            <p className="text-base md:text-lg leading-relaxed font-sans !text-[hsl(0,0%,100%)]">The highest level of leadership means being established in the unified field of consciousness, infinite silence and coherence.<div><br /></div><div>Then functioning from here you make the right decisions that protects and enhances everyone’s progress, without ego or mistake of the intellect.</div><div><br /></div><div>Your IQ, EQ &amp; AI helps you process information, but it’s not enough.</div><div><br /></div><div>High leadership consciousness strengthens discernment to integrate all these parts of intelligence to get you the progress you want.</div><div><br /></div><div>The unified field of consciousness represents 100% mental capacity, when established in this field you have the right thought to make the right decision to create the right experience.</div><div><br /></div><div>High leadership consciousness is what gives you the equanimity to create space between stimulus and response.</div><div><br /></div></p>
          </div>
          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-[480px]">
              <AspectRatio ratio={3 / 4}>
                <img src="https://newmavericks.com/wp-content/uploads/2026/03/New-Mavericks-Insider-Framework.png" alt="CEO Leadership Excellence" className="rounded-lg shadow-strong object-cover w-full h-full" />
              </AspectRatio>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {videoLibrary.map((video, index) => <div key={video.id} data-index={index} className="col-span-12 md:col-span-6 lg:col-span-4">
              <Dialog>
                <Card className="h-full rounded-lg border border-black/10 bg-white shadow-soft hover:shadow-strong transition-all duration-300 overflow-hidden flex flex-col group">
                  <DialogTrigger asChild>
                    <div className="relative cursor-pointer overflow-hidden bg-slate-200">
                      <AspectRatio ratio={16 / 9}>
                        <img src={video.thumbnail} alt={video.title} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" />
                        <div className="absolute inset-0 bg-black/10 group-hover:bg-black/30 transition-colors duration-300" />
                        
                        {}
                        <div className="absolute inset-0 flex items-center justify-center opacity-90 group-hover:opacity-100 transition-opacity duration-300">
                          
                        </div>
                      </AspectRatio>
                    </div>
                  </DialogTrigger>
                  
                  <CardContent className="p-6 flex-1 flex flex-col">
                    
                    
                    <h3 className="font-display text-xl font-bold leading-tight mb-3 text-black group-hover:text-accent transition-colors">
                      {video.title}
                    </h3>
                    
                    <p className="text-slate-600 text-sm leading-relaxed font-sans !m-0">
                      {video.description}
                    </p>
                  </CardContent>
                </Card>

                <DialogContent className="sm:max-w-4xl p-0 overflow-hidden bg-black border-none rounded-lg">
                  <div className="sr-only">
                    <DialogTitle>{video.title}</DialogTitle>
                    <DialogDescription>Video player for {video.title}</DialogDescription>
                  </div>
                  <AspectRatio ratio={16 / 9} className="bg-black flex items-center justify-center relative">
                    {}
                    <img src={video.thumbnail} alt={`${video.title} poster`} className="absolute inset-0 w-full h-full object-cover opacity-40" />
                    <div className="relative z-10 flex flex-col items-center text-white text-center px-4">
                      <div className="w-20 h-20 bg-accent rounded-lg flex items-center justify-center mb-6 shadow-strong animate-pulse">
                        <Play className="w-8 h-8 fill-current text-white ml-1" />
                      </div>
                      <p className="font-sans text-sm tracking-[0.2em] uppercase text-accent font-bold">New Mavericks Presentation</p>
                      <p className="font-display text-2xl font-bold mt-4 max-w-2xl">{video.title}</p>
                      <div className="mt-8 flex gap-4">
                        <button className="bg-accent hover:bg-accent-hover text-white px-8 py-3 rounded-md font-bold transition-colors">
                          Play Full Experience
                        </button>
                      </div>
                    </div>
                  </AspectRatio>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>

      </div>
    </section>;
}